import BarChart from "components/Reports/BarChart";
import Gauge from "components/Reports/Gauge";
import NormalizeSeriesChart from "components/Reports/NormalizeSeries";
import Prediction from "components/Reports/Prediction";
import TimeSeriesChart from "components/Reports/TimeSeriesChart";

export const ReportChartComponents = {
  Timeseries: TimeSeriesChart,
  Gauge: Gauge,
  Normalization: NormalizeSeriesChart,
  Prediction: Prediction,
  BarChart: BarChart
};

export const NORMALIZED_FILTERS = {
  production: "TAG034",
  feedFlow: "TAG071",
  conductivity: "TAG088"
};

export const NormalizedFiltersStrings = {
  TAG034: "",
  TAG071: "",
  TAG088: ""
};
